import { useParams } from "react-router-dom";
import Shimmer from "./Shimmer";
import RestaurantSummary from "./RestaurantSummary";
import useRestaurant from "../utils/useRestaurant";
import NestedItemsCard from "./NestedItemsCard";
import RestaurantMenuShimmer from "./RestaurantMenuShimmer";

const RestaurantMenu = () => {
  /*const params = useParams();
    console.log(params);*/

  // call useParams and get value of restaurant id using object destructuring
  const { restaurantId } = useParams();

  const restaurant = useRestaurant(restaurantId);
  // console.log(restaurant);


  if (!restaurant) {
    return <RestaurantMenuShimmer />;
  }

  return (
    <div data-testid="menu">
      <RestaurantSummary restaurant={restaurant.summary} />
      <div className="w-11/12 md:w-4/5 lg:w-3/5 mx-auto">
        {restaurant.menuItems.map((nestedItems) => (
          <NestedItemsCard nestedItems={nestedItems} key={nestedItems.title} />
        ))}
      </div>
    </div>
  );
};

export default RestaurantMenu;
